import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  OnDestroy,
  ViewChild,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SetDefaultTitle } from '@epicuro-next/directives/set-default-title';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { BuilderContentStore } from './builder-content.store';

@Component({
  selector: 'epc-builder-content-component',
  templateUrl: './builder-content.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./builder-content.component.scss'],
  providers: [BuilderContentStore],
  hostDirectives: [SetDefaultTitle],
  standalone: false,
})
export class BuilderContentComponent implements OnDestroy, AfterViewInit {
  @ViewChild('builder')
  public builderRef: ElementRef<HTMLElement>;

  public builderLoading$ = this.builderContentStore.builderLoading$;
  public builderHasError$ = this.builderContentStore.builderHasError$;

  public destroy$ = new Subject<void>();

  constructor(
    private route: ActivatedRoute,
    private builderContentStore: BuilderContentStore,
  ) {
    this.onActiveRouteChanges();
  }

  public ngAfterViewInit() {
    this.builderContentStore.setTargetRef(this.builderRef.nativeElement);
  }

  public ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private onActiveRouteChanges() {
    this.route.params
      .pipe(takeUntil(this.destroy$))
      .subscribe(({ site, templateId }) => {
        this.builderContentStore.destroyLandingPage();
        this.builderContentStore.fetchTemplate({ site, templateId });
      });
  }
}
